import { IMockHandler } from '@/mock/mock.handler.interface';
import { okDeleted, okSingle } from '@/mock/mock.response.util';
import { APPLICATION_LICENSE_FIXTURES } from '@/mock/application-license/application-license.fixtures';

const ID_ROUTE = /\/application-license\/([^/?]+)$/;

export const applicationLicenseHandler: IMockHandler = {
    matches(req: any) {
        if (req.url.includes('/assets/i18n/') || req.url.includes('assets/i18n/')) {
            return false;
        }

        const matches = req.url.includes('/application-license')

        console.log('[ApplicationLicenseHandler.matches] Returning:', matches);
        return matches;
    },

    handle(req: any) {
        const { method, url } = req;
        const idMatch = url.match(ID_ROUTE);

        // ── GET /application-license/:id ────────────────────────────────────────
        if (method === 'GET' && idMatch) {
            const found = APPLICATION_LICENSE_FIXTURES
            return found ? okSingle(found) : okSingle(null);
        }

        // ── GET /application-license ────────────────────────────────────────────
        if (method === 'GET' && url.endsWith('/application-license')) {
            return okSingle(APPLICATION_LICENSE_FIXTURES);
        }

        // ── POST /application-license ───────────────────────────────────────────
        if (method === 'POST' && url.endsWith('/application-license')) return okSingle({ ...req.body, id: Date.now() });

        // ── PUT /application-license/:id ────────────────────────────────────────
        if (method === 'PUT' && idMatch) {
            return okSingle({ ...APPLICATION_LICENSE_FIXTURES, ...req.body });
        }

        // ── DELETE /application-license/:id ─────────────────────────────────────
        if (method === 'DELETE' && idMatch) return okDeleted();

        throw new Error(`[ApplicationLicenseHandler] unhandled: ${method} ${url}`);
    }
};
